(function() {
  const footerElement = document.querySelector('footer.section-wrapper');
  if (!footerElement) return;
  const footer = /** @type {HTMLElement} */ (footerElement);

  function applyMediaOverlap() {
    // Find all elements with the 'media-overlap' class
    const overlapElements = document.querySelectorAll('.media-overlap');
    
    // Exit early if no overlap elements exist
    if (overlapElements.length === 0) {
      footer.style.marginTop = '';
      return;
    }
    
    overlapElements.forEach(function(el) {
      const element = /** @type {HTMLElement} */ (el);
      const height = element.offsetHeight;
      const negativeMargin = -(height / 2);
      
      // Apply negative margin-top to the element
      element.style.marginTop = negativeMargin + 'px';
      
      // Apply positive margin-top to the footer to compensate
      footer.style.marginTop = Math.abs(negativeMargin) + 'px';
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMediaOverlap);
  } else {
    applyMediaOverlap();
  }

  // Re-run on window resize
  window.addEventListener('resize', applyMediaOverlap);
})();

